import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { AuthenticationService, CommonPlatformService, Platform, ConfigService, CommonUtil } from 'psd-common';

@Component({
    selector: 'central-login-contact-admin',
    templateUrl: 'central-login-contact-admin.component.html'
})
export class CentralLoginContactAdminComponent implements OnInit {
    public platformPrefix: string;
    public email: string;
    public captcha: string;
    public submitted: boolean = false;
    public submitting: boolean = false;
    public isContactSuccessful: boolean = false;
    public messageSent: boolean = false;

    public currentPlatform: Platform;
    public contactForm: FormGroup;

    @ViewChild('invisibleRecaptcha') public invisibleRecaptcha: ElementRef;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        private router: Router,
        private authenticationService: AuthenticationService,
        private formBuilder: FormBuilder,
        private platformService: CommonPlatformService,
        private configService: ConfigService,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.renderer.addClass(this.document.body, 'login');

        this.route.queryParams.subscribe(_params => {
            this.contactForm = this.formBuilder.group(
              {
                  firstName: ['', [Validators.required]],
                  lastName: ['', [Validators.required]],
                  email: ['', [Validators.required, Validators.email]],
                  message: ['', [Validators.required]]
              },
              {}
            );

            this.platformPrefix = _params.platform;
            this.email = _params.email;

            if(this.email) {
                this.contactForm.setValue({
                    'firstName' : '',
                    'lastName' : '',
                    'email' : this.email,
                    'message': ''
                });
            }

            this.platformService.getExternalPlatformDetails(this.platformPrefix).subscribe(_result => {
                this.currentPlatform = _result;
            });
        });


    }

    executeCaptcha() {
        // @ts-ignore
        this.invisibleRecaptcha.execute();
    }

    send() {
        this.submitting = true;
        this.submitted = true;

        if (this.contactForm.invalid && !this.captcha) {
            this.submitting = false;
            return;
        }

        let baseURL = CommonUtil.getBaseURL(this.platformPrefix, 'api', environment.production, this.currentPlatform.domainExtension);
        let json = JSON.parse(JSON.stringify(this.contactForm.value, null, 4));
        let me = this;
        setTimeout(function() {
            if(me.captcha) {
                let processedMessage = CommonUtil.filterTextFromCommentsAndStyling(json.message);
                processedMessage = processedMessage.replace(/<script(.)*?>|<\/script>/g, '');
                me.platformService.contactPlatformAdmin(json.firstName, json.lastName, json.email, processedMessage, false, environment.recaptcha.serverKey, me.captcha, baseURL).subscribe(_result => {
                    me.isContactSuccessful = _result;
                    me.messageSent = true;
                });
            }
        }, 500);
    }

    process() {
        this.executeCaptcha();
        this.send();
    }

    get form() {
        return this.contactForm.controls;
    }

    public setCaptchaToken(token: string | null) {
        this.captcha = token;
    }
}
